import React, { useContext, useState, useEffect } from 'react';
import { GameContext } from '../../store/game/GameContext';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { editGame, getgame } from '../../api/user';

const EditGame = () => {
  const { gameList } = useContext(GameContext);
  const { id } = useParams();
  const gameId=parseInt(id);
  console.log(id);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const user_id = userInfo.id; // Getting user_id from local storage

  const gameToEdit = gameList.find(game => game.id === parseInt(id));
  const [formData, setFormData] = useState({});

    const [isEditMode, setIsEditMode] = useState(false);

  // Effect to determine if the formData has a past date when loading
  useEffect(() => {
    if (formData.start_date) {
      const currentDate = new Date();
      const startDate = new Date(formData.start_date);

      // Check if the start date is in the past
      if (startDate < currentDate) {
        setIsEditMode(true);
      } else {
        setIsEditMode(false);
      }
    }
  }, [formData.start_date]);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = () => {
    const validationErrors = {};

    // Validate title
    if (!formData.title) validationErrors.title = "League title is required.";

    // Validate reward
    if (!formData.reward || formData.reward <= 0) {
      validationErrors.reward = "Reward must be a positive number.";
    }

    // Validate sponsor
    if (!formData.sponsor) validationErrors.sponsor = "Sponsor is required.";

    // Validate credit
    if (!formData.credit || formData.credit < 0) {
      validationErrors.credit = "Credit must be a positive number.";
    }

    // Validate password for private games
    if (formData.game_type === "private" && !formData.password) {
      validationErrors.password = "Password is required for private games.";
    }

    // Validate start date (today or future date)
    if (formData.start_date) {
      const startDate = new Date(formData.start_date);
      const now = new Date();
      now.setHours(0, 0, 0, 0); // Normalize to midnight for comparison

      if (startDate < now && formData.start_date !== formData.start_date) {
        validationErrors.start_date = "Start date cannot be in the past.";
      }
    }

// Validate end date (must be greater than or equal to start date)
if (formData.end_date && formData.start_date) {
  const startDate = new Date(formData.start_date);
  const endDate = new Date(formData.end_date);
  if (endDate < startDate) {
    validationErrors.end_date = "End date must be greater than or equal to start date.";
  }
}


    return validationErrors;
  };

  const formatDateForSubmission = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().slice(0, 19).replace('T', ' '); // Format to "YYYY-MM-DD HH:mm:ss"
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const updatedGameData = {
      ...formData,
      start_date: formData.start_date ? formatDateForSubmission(formData.start_date) : formData.start_date,
      end_date: formData.end_date ? formatDateForSubmission(formData.end_date) : formData.end_date,
      password: formData.game_type === "private" ? formData.password : null,
    };

    try {
      const response = await editGame(updatedGameData);
      if (response.status === 200) {
        toast.success("League updated successfully!");
        // setFormData({
        //   id: parseInt(id),
        //   user_id: user_id,
        //   title: "",
        //   description: "",
        //   start_date: "",
        //   end_date: "",
        //   reward: "",
        //   sponsor: "",
        //   game_type: "public",
        //   password: "",
        //   credit: "",
        //   join_after_start: false,
        //   private_portfolio: false,
        // });
        setErrors({});
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
      console.error("Failed to edit game", error);
    }
  };

  // useEffect(() => {
  //   if (!gameToEdit) {
  //     toast.error("Game not found.");
  //   }
  // }, []);


    const fetchGame = async (Id) => {
    try {
      const response = await getgame({ game_id: Id });
      if (response) {
        const gameData = response?.data?.data;
        console.log(gameData);
              setFormData({
        ...gameData,
        start_date: gameData.start_date.slice(0, 10), // Format to 'YYYY-MM-DD'
        end_date: gameData.end_date.slice(0, 10),     // Format to 'YYYY-MM-DD'
      });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
      fetchGame(gameId);
  }, []);



  return (
    <div className="flex flex-col items-center mt-4">
      <h2 className="text-2xl font-semibold text-center mb-6 text-green-600">Edit Game</h2>
      <form onSubmit={handleSubmit} className="w-full max-w-md">
        {/* Title */}
        <label htmlFor="title" className="block mb-1">Game Title:</label>
        <input
          type="text"
          id="title"
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="w-full p-2 border rounded mb-2"
        />
        {errors.title && <div className="text-red-500">{errors.title}</div>}

        {/* Description */}
        <label htmlFor="description" className="block mb-1">Description:</label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="w-full p-2 border rounded mb-2"
        />

        {/* Start Date */}
        <label htmlFor="start_date" className="block mb-1">Start Date:</label>
        <input
          type="date" // Change to date input
          id="start_date"
          name="start_date"
          value={formData.start_date}
          onChange={handleChange}
        //  min={new Date().toISOString().slice(0, 10)} // Disable past dates
      //  min={isEditMode ? new Date().toISOString().slice(0, 10) : undefined}
          className="w-full p-2 border rounded mb-2"
        />
        {errors.start_date && <div className="text-red-500">{errors.start_date}</div>}

        {/* End Date */}
        <label htmlFor="end_date" className="block mb-1">End Date:</label>
        <input
          type="date" // Change to date input
          id="end_date"
          name="end_date"
          value={formData.end_date}
          onChange={handleChange}
          min={formData.start_date || new Date().toISOString().slice(0, 10)}
          className="w-full p-2 border rounded mb-2"
        />
        {errors.end_date && <div className="text-red-500">{errors.end_date}</div>}

        {/* Reward */}
        <label htmlFor="reward" className="block mb-1">Reward:</label>
        <input
          type="number"
          id="reward"
          name="reward"
          value={formData.reward}
          onChange={handleChange}
          className="w-full p-2 border rounded mb-2"
        />
        {errors.reward && <div className="text-red-500">{errors.reward}</div>}

        {/* Sponsor */}
        <label htmlFor="sponsor" className="block mb-1">Sponsor:</label>
        <input
          type="text"
          id="sponsor"
          name="sponsor"
          value={formData.sponsor}
          onChange={handleChange}
          className="w-full p-2 border rounded mb-2"
        />
        {errors.sponsor && <div className="text-red-500">{errors.sponsor}</div>}

        {/* Game Type */}
        <label className="block mb-1">Game Type:</label>
        <select
          name="game_type"
          value={formData.game_type}
          onChange={handleChange}
          className="w-full p-2 border rounded mb-2"
        >
          <option value="public">Public</option>
          <option value="private">Private</option>
        </select>

        {/* Password for private game */}
        {formData.game_type === "private" && (
          <>
            <label htmlFor="password" className="block mb-1">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full p-2 border rounded mb-2"
            />
            {errors.password && <div className="text-red-500">{errors.password}</div>}
          </>
        )}

        {/* Credit */}
        <label htmlFor="credit" className="block mb-1">Credit:</label>
        <input
          type="number"
          id="credit"
          name="credit"
          value={formData.credit}
          onChange={handleChange}
          className="w-full p-2 border rounded mb-2"
        />
        {errors.credit && <div className="text-red-500">{errors.credit}</div>}

        {/* Join After Start */}
        <label htmlFor="join_after_start" className="flex items-center mb-2">
          <input
            type="checkbox"
            id="join_after_start"
            name="join_after_start"
            checked={formData.join_after_start}
            onChange={handleChange}
            className="mr-2"
          />
          Allow joining after the start date
        </label>

        {/* Private Portfolio */}
        <label htmlFor="private_portfolio" className="flex items-center mb-4">
          <input
            type="checkbox"
            id="private_portfolio"
            name="private_portfolio"
            checked={formData.private_portfolio}
            onChange={handleChange}
            className="mr-2"
          />
          Private Portfolio
        </label>

        <button type="submit" className="bg-green-600 text-white p-2 rounded">Update Game</button>
      </form>
    </div>
  );
};

export default EditGame;
